import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  solutionsList: {
    data: [],
  },
};

export const solutionsSlice = createSlice({
  name: "solutions",
  initialState: initialState,
  reducers: {
    getSolutionsList: (state, action) => {
      state.solutionsList = action.payload;
    },
  },
});

export const selectSolutionsList = (state) => state.solutions.solutionsList;

export const { getSolutionsList } = solutionsSlice.actions;
export default solutionsSlice.reducer;
